import { AxiosResponse } from 'axios';
import { ASSETS_API_URL } from '../../../../config';
import assetsAxios from '../../../../utils/axios/assets.axios';

const tryToFetchAssetCurrencies = (): Promise<AxiosResponse<any>> => {
    const url = `${ASSETS_API_URL}/dom/currency/assets`
    return assetsAxios.get<any>(url)
}

export const AssetsServicee = {
    tryToFetchAssetCurrencies
}